module.exports = __webpack_public_path__ + "img/DW365-331.e737ca49.jpg";